import { useAuthDependencies } from '@/composables/api/auth'
import { useQuery } from '@tanstack/vue-query'

export const useHelpDocsQuery = () => {
  const authGetter = useAuthDependencies()
  const { data, status, isSuccess } = useQuery({
    queryKey: ['helpDocs'],
    queryFn: async ({ signal }) => {
      const { axios } = await authGetter()
      return axios({
        method: 'GET',
        url: `/api/v2/workforce_intelligence/user_guide`,
        signal
      }).then((data) => {
        return data.data.url
      })
    },
    enabled: true
  })
  return {
    data,
    status,
    isSuccess
  }
}
